/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Sales_Return_IncreaseInputs */

const vi_sales_return_increase = /** @type {(inputs: Sales_Return_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tăng ${i?.label}`)
};

/**

* @param {Sales_Return_IncreaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_increase = /** @type {((inputs: Sales_Return_IncreaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_IncreaseInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_increase(inputs)
});